<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="!isPage && page"
      :show-checkbox="!is_listDialog && isShow"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.list"
      urlHash="business/purchase/stock"
      @row-select="showRow"
      :showTrendTable="isShow"
      :resetDataFunc="!isFunc && resetDataFunc"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>

      <template slot="query">
        <el-form-item label="业务类型" label-width="100px">
          <el-select
            v-model="params.BusinessTypeId"
            clearable
            :disabled="isSelect"
          >
            <el-option
              v-for="item in businessTypeList"
              :key="item.BusinessTypeId"
              :label="item.BusinessType"
              :value="item.BusinessTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>

      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button
      v-if="show"
      type="primary"
      @click="onCustomTable"
      icon="el-icon-s-tools"
      style="margin: 30px 0 10px 10px"
    >
      明细项
    </el-button>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.Prop"
      :data="subList"
      v-if="show"
      stripe
      border
      @selection-change="handleSelectionChange"
      :summary-method="summaryFunc"
      show-summary
    >
      <el-table-column v-if="is_listDialog" type="selection" width="55">
      </el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog
      ref="customTableDialog"
      @onSave="onSave"
      :initTableData="tableColumns"
      tableType="采购订单明细"
    />
    <!-- <el-table ref="multipleTable" class="subItem-table" :data="subList" v-if="show"
      @selection-change="handleSelectionChange" tooltip-effect="dark" border :summary-method="summaryFunc" show-summary>
      <el-table-column v-if="is_listDialog" type="selection" width="55"> </el-table-column>
      <el-table-column align="left" prop="ProductNo" label="存货编码"></el-table-column>
      <el-table-column align="left" prop="ProductName" label="存货名称" min-width="140px"
        show-overflow-tooltip></el-table-column>
      <el-table-column align="left" prop="ProductSpec" label="规格"></el-table-column>
      <el-table-column align="left" prop="ColorName" label="颜色"></el-table-column>
      <el-table-column align="left" prop="PuUnitName" label="计量单位"></el-table-column>
      <el-table-column align="right" prop="PuQuantity" label="数量">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PuQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Price" label="单价" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="Amount" label="金额" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Rate" label="税率" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="TaxPrice" label="含税单价" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="TaxAmount" label="含税金额" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

import tableColumn from "@/data/business/purchase/stock/list.json";
import tableParam from "@/data/business/purchase/stock/query.json";

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    showTrendTable: {
      type: Boolean,
      default: true,
    },
    modelType: {
      type: String,
      default: "",
    },
    isFunc: {
      type: Boolean,
      default: true,
    },
    isPage: {
      type: Boolean,
      default: false,
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  data() {
    return {
      api: require("@/api/pu/puDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      orderNo: "",
      TradeUnitId: 0,
      TradeUnitName: "",
      InvoiceTypeId: null,
      InvoiceTypeName: null,
      PayId: null,
      PayName: null,
      BusinessTypeId: null,
      show: false,
      subSelectList: [],
      subList: [],
      params: {
        BusinessTypeId: null,
      },
      tempParams: {},
      businessTypeList: [],
      ordertype: "",
      tableColumns: [],
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/purchase/stock");
    },
  },
  activated() {
    this.getRouterInfo();
  },
  mounted() {
    this.getBusinessType();
    this.getTableColumns();
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
        "Rate",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["PuQuantity", "Amount", "TaxAmount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "采购订单明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
    },
    getBusinessType() {
      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "进货单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
              }
            });
        }
      });
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.SourceOrderId = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceDocId,
        };
        this.tempParams.SourceType = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceType,
        };
        this.tempParams.Ids = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.Ids,
        };
        this.$refs.list.getData();
      }
    },
    resetDataFunc(data) {
      let newData = [];
      let dataLengt = data.length;
      for (let i = 0; i < dataLengt; ++i) {
        if (i >= 10) {
          break;
        } else {
          newData.push(data[i]);
        }
      }
      console.log("newData", newData);
      return newData;
    },
    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    toggleSelection(rows) {
      let $multipleTable = this.$refs.multipleTable;
      if ($multipleTable) {
        if (rows) {
          rows.forEach((row) => {
            $multipleTable.toggleRowSelection(row);
          });
        } else {
          $multipleTable.clearSelection();
        }
      }
    },
    clearSubSelectList() {
      this.toggleSelection();
    },
    clearList() {
      this.subSelectList = [];
      this.show = false;
    },
    showRow(data) {
      console.log("this.ordertype", this.ordertype);
      // console.log('当前行',data);
      // if (!this.is_listDialog) return;
      this.show = false;
      this.api.info(data.DocId).then((res) => {
        if (res.Code === 0 && res.Data.length != 0) {
          this.show = true;
          this.orderNo = res.Data.DocNo;
          this.TradeUnitId = res.Data.TradeUnitId;
          this.TradeUnitName = res.Data.TradeUnitName;
          this.InvoiceTypeId = res.Data.InvoiceTypeId;
          this.InvoiceTypeName = res.Data.InvoiceTypeName;
          this.PayId = res.Data.PayId;
          this.PayName = res.Data.PayName;
          this.BusinessTypeId = res.Data.BusinessTypeId;

          if (this.isSelect) {
            res.Data.Products.forEach((item) => {
              if (this.ordertype == "采购入库单") {
                item.PuQuantity =
                  item.PuQuantity - (item.StInOccupyQuantity ?? 0);
              } else {
                item.PuQuantity =
                  item.PuQuantity - (item.PuBillOccupyQuantity ?? 0);
              }

              item.Amount = item.PuQuantity * item.Price;
              item.TaxAmount = item.PuQuantity * item.TaxPrice;
            });

            let tList = res.Data.Products.filter((x) => x.PuQuantity != 0);
            console.log("tList", tList);
            this.subList = tList;
          } else {
            this.subList = res.Data.Products;
          }
        }
      });
      // this.subList.push(data)
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    summaryFunc(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) console.log("data", column, data);
        //数量 getQuantity
        const arr1 = ["PuQuantity", "Quantity2"];
        //金额 固定2位小数
        const arr2 = ["Amount", "TaxLimit", "TaxAmount", "DiscountAmount"];
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (arr1.indexOf(column.property) > -1 ||
            arr2.indexOf(column.property) > -1)
        ) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (arr1.indexOf(column.property) != -1) {
            v = Number(v);
          }
          if (arr2.indexOf(column.property) != -1) {
            v = v.toFixed(2);
            let vStr = v.toString().split(".");
            if (Number(vStr[1]) <= 0) v = vStr[0];
          }
          if (v > 0) {
            v = Number(v).toLocaleString();
          }
          sums[index] = v;
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    reviewAll(ids) {
      this.api.reviewAll({ ids }).then((res) => {
        this.$message({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: `<div class="my-message">${res.Msg}</div>`,
          type: res.Code == 0 ? "success" : "warning",
        });
        if (res.Code == 0) this.reload();
      });
    },
    backAll(ids) {
      this.api.backAll({ ids }).then((res) => {
        this.$message({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: `<div class="my-message">${res.Msg}</div>`,
          type: res.Code == 0 ? "success" : "warning",
        });
        if (res.Code == 0) this.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
